import React, { useContext, useRef } from 'react';
import { CanvasContext } from 'components/upload-image/CanvasContext';
import useRegisterTooltipTarget from 'components/useRegisterTooltipTarget';

export default function ToolButton({
  activeTool,
  setActiveTool,
  tool,
  mainTooltipSequence,
}) {
  const { requestRotateExit } = useContext(CanvasContext);
  const { type, title } = tool;
  const toolButtonRef = useRef(null);

  const tooltipIdMap = {
    rotate: 'rotate-tool',
    adjust: 'adjust-tool',
    filters: 'filter-tool',
  };

  useRegisterTooltipTarget(
    mainTooltipSequence,
    tooltipIdMap[type] || `tool-${type}`,
    toolButtonRef,
  );

  const getStyle = (toolType) => {
    return toolType === activeTool ? 'bg-white' : 'bg-md-beige';
  };

  return (
    <button
      ref={toolButtonRef}
      className={`${getStyle(
        type,
      )} rounded-lg py-2 px-4 text-sm shrink-0 md:w-full block my-3 flex items-center mr-4 md:mr-0 snap-center`}
      onClick={() => {
        const go = () => setActiveTool(type);
        if (typeof requestRotateExit === 'function') requestRotateExit(go);
        else go();
      }}
    >
      <img
        src={`${process.env.PUBLIC_URL}/images/${type}.png`}
        alt={title}
        className="w-[20px] h-[20px] mr-2"
      />
      {title}
    </button>
  );
}
